export const IS_PRERENDER =
  typeof window !== "undefined" &&
  (window.__REACT_SNAP__ === true ||
    window.__REACT_SNAP__ === "true" ||
    (window.navigator &&
      typeof window.navigator.userAgent === "string" &&
      window.navigator.userAgent.includes("ReactSnap")) ||
    (typeof document !== "undefined" &&
      document.documentElement &&
      document.documentElement.hasAttribute &&
      document.documentElement.hasAttribute("data-react-snap")));
